<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import { BaseDialog } from '@/components/Modals/Dialog'
import store from '@/store'
import { ECheckpointActions } from '@/store/checkpointStore/CheckpointStoreTypes'
import { EStoreModules } from '@/store/storeType'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { ref } from 'vue'
import EventCreateCheckpointInputs from './EventCreateCheckpointInputs.vue'

type Props = {
    siteId: number
    open: boolean
    partnerConfig?: PartnerModel
}
const props = defineProps<Props>()
const emit = defineEmits<{
    (e: 'refresh'): void
    (e: 'close'): void
}>()

const isSubmitted = ref(false)
const data = ref<Partial<CheckpointModel>>({ comments: '' })
const createCheckpoint = () => {
    isSubmitted.value = true
    if (!data.value.name) return
    store
        .dispatch(`${EStoreModules.CHECKPOINT}/${ECheckpointActions.CREATE_CHECKPOINT}`, {
            siteId: props.siteId,
            data: data.value
        })
        .then(() => {
            emit('refresh')
            isSubmitted.value = false
            data.value = { comments: '' }
        })
}
</script>

<template>
    <BaseDialog
        :open="open"
        :title="$t('event.detail.pois.createCheckpointTitle')"
        :loading="!!store.state.checkpoint.isLoading"
        @confirm="createCheckpoint"
        @close="$emit('close')">
        <template #content>
            <StackLayout direction="column" :gap="16">
                <EventCreateCheckpointInputs
                    :data="data"
                    :siteId="siteId"
                    :isSubmitted="isSubmitted"
                    @change="data = { ...data, ...$event }" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
